import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { verifyToken } from '../../services/auth';

const TokenHandler = () => {
	const { authenticate } = useAuth();
	const [searchParams] = useSearchParams();
	const token = searchParams.get('token');

	useEffect(() => {
		const checkToken = async () => {
			const response = await verifyToken(token);
			const hasAccess = response.addOnList && response.addOnList.some((addOn) => addOn.type === 'SOCRATES');
			if (response.user && hasAccess) {
				authenticate(response.user, token, false);
			}
		};

		if (token) {
			checkToken();
		}
	}, [token, authenticate]);

	return null;
};

export default TokenHandler;
